import { call, put, takeEvery } from "redux-saga/effects";
import {GET_OTP_SUCCESS, GET_OTP_FAILED, GET_OTP_REQUESTED} from "resources/actionTypes";
import { otpApi } from "services/OtpService";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getProfile } from "redux/actions/UserProfile";
import { onLoaderTrigger } from "redux/actions/CommonAction";
import store from "redux/store";
import { fetchRolesAndPermissions } from "redux/actions/RolesAndPermissionsAction";

function* fetchOtp(action) {
    const payload = action.payload || {};
    store.dispatch(onLoaderTrigger(true));
    const userOtp = yield call(otpApi, payload.userOtp);
    if(userOtp.success){
      localStorage.setItem('token', userOtp?.data[0]?.token)
      localStorage.setItem('role', userOtp?.data[0]?.userType)
      localStorage.setItem('ID', userOtp?.data[0]?.id)

      yield put({ type: GET_OTP_SUCCESS, userOtp: userOtp });
      toast.success(userOtp.message);
      store.dispatch(fetchRolesAndPermissions('auth'));
      store.dispatch(getProfile('auth'));
    } else{
      yield put({ type: GET_OTP_FAILED, message: userOtp.message });
      toast.error(userOtp.message || 'Otp failed');
      store.dispatch(onLoaderTrigger(false));
        payload?.otpActions?.resetOtp();
        payload?.otpActions?.setAutoFocusOtp(true);
    }
}

function* otpSaga() {
  yield takeEvery(GET_OTP_REQUESTED, fetchOtp);

}

export default otpSaga;
